<div class="container-header">
  @if (breadcrumb) {
    <pr-breadcrumb [links]="breadcrumb" class="mbs"></pr-breadcrumb>
  }
  <div class="pr-page-title">
    <div class="mbxl pr-page-title-btn">
      <div>
        <h1 class="mbs">
          @if (hasColorSquare) {
            <div class="color-square"></div>
          }
          {{ title }}
          @if (secondTitle) {
            <span class="secondTitle">{{ secondTitle }}</span>
          }
        </h1>
        <span class="subtitle">{{ subtitle }}</span>
      </div>
      <div class="pr-page-button">
        <ng-content select="[page-button]"></ng-content>
        <ng-content select="[title-button]"></ng-content>
      </div>
    </div>
    <div class="text-right">
      <h4 class="fs-22 fw-600 mtn">{{ otherTitle }}</h4>
      <span class="fs-16 fw-400">{{ otherSubtitle }}</span>
    </div>
  </div>
  <div
    #headerContent
    class="pr-header-content"
    [ngClass]="{ mbxl: headerContent.children.length }"
  >
    <ng-content></ng-content>
  </div>
  <div class="pr-page-actions">
    <ng-content select="[page-action]"></ng-content>
    <ng-content select="[title-action]"></ng-content>
  </div>
  @if (menus) {
    <pr-page-header-menu [menus]="menus"></pr-page-header-menu>
  }
  <pr-tabs-2 [tabs]="tabs"></pr-tabs-2>
</div>
